export class HttpError extends Error {
  status: number
  data: unknown

  constructor(status: number, data: unknown, ...params: string[]) {
    super(...params)

    if ('captureStackTrace' in Error) {
      ;(Error as { captureStackTrace?: (target: Error, constructor: Function) => void }).captureStackTrace?.(this, HttpError)
    }

    this.name = 'HttpError'
    this.status = status
    this.data = data
  }
}
